export default __webpack_public_path__ + "static/media/statisticTwo.34e16314.svg";